// 9fbef606107a605d69c0edbcd8029e5d
import ExtendableError from 'es6-error';
import CheckoutConstants from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';

const GLOBAL_ERROR = '_error';
export const ERRORS = {
  SYSTEM_ERROR: 'Your action could not be completed due to system error',
};

class ServiceError {
  constructor(errorCodes, errorMessages, networkStatusCode, misc, errorMessageParam) {
    this.errorCodes = errorCodes || '';
    // Disabling eslint for temporary fix
    // eslint-disable-next-line no-undef
    this.errorMessages = errorMessages === 'object' ? { errorMessages: { _error } } : errorMessages;
    this.networkStatusCode = networkStatusCode || '';
    this.misc = misc || '';
    this.errorMessageParam = errorMessageParam || '';
  }
}

function populateErrorPlaceholder(errMsg, error) {
  let errorMsg = errMsg;
  // eslint-disable-next-line
  const regex = /\$\{([^\}]+)\}/g;
  const matches = errorMsg?.match ? errorMsg.match(regex) : null;
  if (matches) {
    matches.forEach((match) => {
      // eslint-disable-next-line
      const key = match.replace(/[\$\{\s\}]/g, '');
      errorMsg = errorMsg.replace(match, error[key] || match);
    });
  }
  return errorMsg;
}

export function getDynamicCodeErrorMessage(error, code) {
  const err = error;
  try {
    // eslint-disable-next-line no-underscore-dangle
    err.errorMessages._error = error.errorMessages._error.replace(/<CODE_PLACEHOLDER>/, code);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
}

export function getFreeShippingMPRErrorMessage(error, couponErr) {
  const err = error;
  try {
    const {
      errorMessages: { _error = '' },
    } = err;
    let message = _error;
    if (couponErr.errorCode === '_TCP_PROMOTION_AVAILABLE_ONLY_FOR_REGISTERED_USER') {
      message = 'Please login to your account to apply this coupon.';
    }
    if (couponErr.errorCode === 'TCP_PROMOTION_NOT_TRANSFERABLE') {
      message =
        'This coupon is not transferable between accounts. Please login to the account associated with this coupon and try again.';
    }
    // eslint-disable-next-line no-underscore-dangle
    err.errorMessages._error = message;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
}

export function getApplyCouponLoyaltyErrorMessage(error, couponErr, errorsMapping) {
  const err = error;
  try {
    const {
      errorMessages: { _error = '' },
    } = err;
    let message = _error;
    if (couponErr.errorCode === 'TCP_PROMOTION_NOT_TRANSFERABLE') {
      message = errorsMapping?.TCP_PROMOTION_NOT_TRANSFERABLE_LOYALTY;
    }
    // eslint-disable-next-line no-underscore-dangle
    err.errorMessages._error = message;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
}

function getErrorList(response) {
  if (response?.body) {
    return (
      (Array.isArray(response?.body?.errors) && response?.body?.errors) ||
      (response?.body?.error &&
        response?.body?.error?.errorCode && [
          {
            errorCode: response.body.error.errorCode,
            errorKey: response.body.error.errorKey,
            errorMessageKey: response.body.error.errorMessageKey,
            errorMessage: response.body.error.errorMessage,
            errorMessageParam:
              response.body.error.errorMessageParam || response.body.error.errorParameters,
          },
        ]) || [
        {
          errorCode: response.body.errorCode || response.body.ErrorCode,
          errorKey: response.body.errorKey,
          errorMessageKey: response.body.errorMessageKey,
          errorMessage: response.body.errorMessage || response.body.ErrorMessage, // ErrorMessage comes in pay secure
          errorMessageParam:
            response.body?.error?.errorMessageParam || response.body?.error?.errorParameters,
        },
      ]
    );
  }
  return [
    {
      errorCode: response.err.errorCode || response.err.ErrorCode,
      errorKey: response.err.errorKey,
      errorMessageKey: response.err.errorMessageKey,
      errorMessage: response.err.errorMessage || response.err.ErrorMessage,
      errorMessageParam:
        response.err?.error?.errorMessageParam || response.err?.error?.errorParameters,
    },
  ];
}

export function getFormattedErrorFromResponse(response, ERRORS_MAP, errorsListData = []) {
  let errorsList;
  if (errorsListData.length > 0) {
    errorsList = errorsListData;
  } else {
    errorsList = getErrorList(response);
  }

  let errorCodes = '';
  const errorMessages = {};

  let errorMessageParamArray = [];
  errorsList.forEach((error) => {
    const errorKey = error.errorKey || error.errorCode || error.errorMessageKey;
    if (ERRORS_MAP[error.errorCode]) {
      errorMessages[GLOBAL_ERROR] = populateErrorPlaceholder(ERRORS_MAP[error.errorCode], error);
      errorMessages.errorParameters = error.errorParameters;
      const { errorParameters } = error;
      errorMessageParamArray = errorParameters;
    } else if (ERRORS_MAP[error.errorKey]) {
      errorMessages[GLOBAL_ERROR] = populateErrorPlaceholder(ERRORS_MAP[error.errorKey], error);
      const { errorParameters } = error;
      errorMessageParamArray = errorParameters;
    } else if (ERRORS_MAP[error.errorMessageKey]) {
      const { errorMessageParam } = error;
      errorMessageParamArray = errorMessageParam;
      errorMessages[GLOBAL_ERROR] = populateErrorPlaceholder(
        ERRORS_MAP[error.errorMessageKey],
        error
      );
    } else {
      // We send the server error as backup in case we don't have the error in our map, but sometimes backend does not have this either so we default it
      errorMessages[GLOBAL_ERROR] = populateErrorPlaceholder(
        error.errorMessage || ERRORS_MAP.DEFAULT,
        error
      );
    }
    errorCodes += (errorCodes ? ', ' : '') + errorKey;
  });

  return new ServiceError(
    errorCodes,
    errorMessages,
    response.status,
    response.misc,
    errorMessageParamArray
  );
}

export function getFormattedError(err, errorMapping, isErrorResponse = false) {
  if (err && err.response && err.response.body !== null) {
    return getFormattedErrorFromResponse(err.response, errorMapping);
    // Disabling eslint foe temporary fix
    // eslint-disable-next-line no-else-return
  } else if (isErrorResponse && err && err.errorResponse !== null) {
    return getFormattedErrorFromResponse(err.errorResponse, errorMapping, [err.errorResponse]);
  } else {
    return err;
  }
}

export function responseContainsErrors(response) {
  // Be paranoid and make sure that we can handle a situation where response.body is undefined
  if (!response || !response.body) {
    return false;
  }
  const responseBody = response.body;
  return !!(
    responseBody.errorCode ||
    responseBody.errorMessageKey ||
    responseBody.errorKey ||
    (responseBody.errors && responseBody.errors.length > 0) ||
    (response.body.error && response.body.error.errorCode)
  );
}

export function responseContainsPaymentErrors(res) {
  // Be paranoid and make sure that we can handle a situation where response.body is undefined
  if (!res || !res.body) {
    return false;
  }
  const responseBody = res.body;
  return (
    responseBody &&
    responseBody.errors &&
    responseBody.errors.length &&
    responseBody.errors[0].errorMessage &&
    responseBody.errors[0].errorType
  );
}

export class ServiceResponseError extends ExtendableError {
  constructor(response) {
    super('API service call response with text reporting an error');
    this.response = response;
    this.response.misc = {};
    // Map Backend error response data to a misc object in our error object
    if (response.body && response.body.retriesCount) {
      this.response.misc.failedLoginAttempts = response.body.retriesCount;
    }
  }
}

export const graphQlErrorHandler = (error, errorsMapping) => {
  const updatedError = { errorResponse: error[0] };

  const err = getFormattedError(updatedError, errorsMapping, true);

  if (err.errorCodes === 'undefined') {
    err.errorMessages = {
      _error: CheckoutConstants.SOMETHING_WENT_WRONG,
    };
  }
  if (err.errorCodes !== 'ERR_PRODUCT_SHIPPING_RESTRICTED') {
    err.isIgnoreMapping = true;
  }
  return err;
};

export const getErrorMessage = (err, errorMapping, isTimeOutErrorApi) => {
  return (
    // eslint-disable-next-line no-underscore-dangle
    (err && err.errorMessages && err.errorMessages._error) ||
    (isTimeOutErrorApi && err && err.message && errorMapping.TIMEOUT_ERROR) ||
    (errorMapping && errorMapping.DEFAULT) ||
    'ERROR'
  );
};

export default {
  getErrorMessage,
};
